import { render, staticRenderFns } from "./SkillsTraining.vue?vue&type=template&id=06dd5512&scoped=true"
import script from "./SkillsTraining.vue?vue&type=script&lang=js"
export * from "./SkillsTraining.vue?vue&type=script&lang=js"
import style0 from "./SkillsTraining.vue?vue&type=style&index=0&id=06dd5512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd5512",
  null
  
)

export default component.exports